export default "__VITE_ASSET__coYNV6aW__"